var map = {
	"./close-icon.svg": "./src/img/close-icon.svg",
	"./header-shape.svg": "./src/img/header-shape.svg",
	"./icon-checks.svg": "./src/img/icon-checks.svg",
	"./icon-strl-white.svg": "./src/img/icon-strl-white.svg",
	"./icon-stuurlui-blue.svg": "./src/img/icon-stuurlui-blue.svg",
	"./icon-stuurlui-global.svg": "./src/img/icon-stuurlui-global.svg",
	"./logo-academie-diap.svg": "./src/img/logo-academie-diap.svg",
	"./logo-academie.svg": "./src/img/logo-academie.svg",
	"./logo-diap-small.svg": "./src/img/logo-diap-small.svg",
	"./logo-diap.svg": "./src/img/logo-diap.svg",
	"./logo-icon-academie.svg": "./src/img/logo-icon-academie.svg",
	"./logo-icon-nieman-group.svg": "./src/img/logo-icon-nieman-group.svg",
	"./logo-icon-norm1.svg": "./src/img/logo-icon-norm1.svg",
	"./logo-icon.svg": "./src/img/logo-icon.svg",
	"./logo-nieman-group-diap.svg": "./src/img/logo-nieman-group-diap.svg",
	"./logo-nieman-group.svg": "./src/img/logo-nieman-group.svg",
	"./logo-small.svg": "./src/img/logo-small.svg",
	"./logo.svg": "./src/img/logo.svg",
	"./section-wave-invert.svg": "./src/img/section-wave-invert.svg",
	"./section-wave.svg": "./src/img/section-wave.svg",
	"./strl-16px.png": "./src/img/strl-16px.png",
	"./strl-36px.png": "./src/img/strl-36px.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/img sync recursive ^\\.\\/.*$";